module.exports = __webpack_public_path__ + "media/src/images/list_on-396ef297afec20d3494b6e9ae5b61cc9.png";